module.exports = __webpack_public_path__ + "static/media/amazon-logo.7f2ae43c.png";